import type {
  PropertyHeroData,
  GalleryImage,
  PropertyStoryData,
  SignatureFeature,
  EssentialInfoGroup,
  PropertyReview,
  PropertyConciergeConfig,
  PropertyInquiryData,
  StickyBookBarData,
} from '../types';

export const heroData: PropertyHeroData = {
  id: 'bella-vita',
  name: 'Bella Vita',
  location: 'Emerald Beach Resort',
  area: 'Panama City Beach',
  bedrooms: '2',
  bathrooms: '2',
  sleeps: 'Up to 6',
  heroImage: 'https://inspirevp.com/wp-content/uploads/2026/08/1.jpg',
};

const orderedGalleryUrls = [
  'https://inspirevp.com/wp-content/uploads/2026/08/1.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/2.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/3.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/4.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/5.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/6.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/7.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/8.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/9.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/10.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/11.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/12.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/16.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/16a.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/16b.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/16c.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/17.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/18.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/19.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/20.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/21.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/21A.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/22.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/23.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/24.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/25.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/26.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/27.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/28.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/29.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/30.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/31.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/32.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/33.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/34.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/35.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/36.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/37.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/38.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/39.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/40-1.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/41-1.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/42.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/43.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-1.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-2.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-3.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-4.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-5.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-6.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-7.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-8.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-9.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-10.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-11.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-12.jpg',
  'https://inspirevp.com/wp-content/uploads/2026/08/60-13.jpg',
];

export const galleryImages: GalleryImage[] = orderedGalleryUrls.map((src, index) => ({
  src,
  alt: `Bella Vita photo ${index + 1}`,
  caption: `Photo ${index + 1} of ${orderedGalleryUrls.length}`,
}));

export const storyData: PropertyStoryData = {
  subheading: 'Gulf-front penthouse, massive balcony, and views for days. Translation: living your best life vibes.',
  paragraphs: [
    'Bella Vita is a 2-bedroom, 2-bath Gulf-front penthouse condo at Emerald Beach Resort in Panama City Beach. Located on the 25th floor, it offers 1,299 square feet, a massive balcony, and broad views of the Gulf of Mexico.',
    'The living area is shaped around the view, with floor-to-ceiling windows, a large flat-screen TV, DVD player, and an easy gathering layout for up to six guests.',
    'The kitchen features black granite countertops, top-of-the-line appliances, a Keurig coffee system, breakfast bar seating for two, and the cookware and supplies needed for a beachside meal. The nearby dining table seats six.',
    'The Gulf-front primary bedroom opens directly to the balcony and includes a king bed, private bathroom, double sinks, a large garden tub, and separate walk-in shower. The guest bedroom has a queen bed, and the bunk area includes twin bunks.',
    'Emerald Beach Resort adds several pools, a hot tub, splash pad, whirlpool spa grotto, tropical pool deck, on-site Starbucks, poolside cafe, covered parking garage, connected sky bridge, and the Sky Bar.',
  ],
  locationContext:
    'Bella Vita is in the heart of Panama City Beach. Pier Park is just down the street with more than 130 shops, restaurants, entertainment venues, and the Grand 16 IMAX Theater. Shipwreck Island Water Park is less than 2 miles away.',
  address: 'Emerald Beach Resort',
  addressSub: 'Panama City Beach, Florida',
  propertyMeta: '2 bedrooms · 2 bathrooms · 1,299 sq. ft. · 25th floor',
};

export const signatureFeatures: SignatureFeature[] = [
  {
    title: 'Gulf-Front Penthouse',
    body: 'Set on the 25th floor of Emerald Beach Resort, Bella Vita looks directly over the white sand and emerald Gulf waters from the balcony, living area, and primary bedroom.',
    image: 'https://inspirevp.com/wp-content/uploads/2026/08/9.jpg',
    imageAlt: 'Bella Vita living room with Gulf view',
    tag: '25th floor',
  },
  {
    title: 'Massive Balcony',
    body: 'The expansive balcony is one of the defining features of the condo, with room to sit outside and take in sunrise, sunset, and broad Gulf views.',
    image: 'https://inspirevp.com/wp-content/uploads/2026/08/2.jpg',
    imageAlt: 'Bella Vita balcony',
    tag: 'Gulf views',
  },
  {
    title: 'Emerald Beach Resort Amenities',
    body: 'The resort offers several pools, a hot tub, splash pad, whirlpool spa grotto, tropical pool deck, on-site Starbucks, poolside cafe, Sky Bar, and covered parking garage.',
    image: 'https://inspirevp.com/wp-content/uploads/2026/08/40-1.jpg',
    imageAlt: 'Emerald Beach Resort amenities',
    tag: 'Resort setting',
  },
  {
    title: 'Beach Chair Setup',
    body: 'Two beach chairs and an umbrella setup are included with rentals from March 1 through October 31.',
    image: 'https://inspirevp.com/wp-content/uploads/2026/08/8.jpg',
    imageAlt: 'Bella Vita beach setup',
    tag: 'Seasonal inclusion',
  },
];

export const essentialInfoGroups: EssentialInfoGroup[] = [
  {
    heading: 'At a glance',
    items: [
      '2 bedrooms',
      '2 bathrooms',
      'Sleeps up to 6 guests',
      '1,299 sq. ft.',
      '25th floor penthouse',
      'Gulf-front condo at Emerald Beach Resort',
    ],
  },
  {
    heading: 'Key features',
    items: [
      'Massive balcony overlooking the Gulf of Mexico',
      '180-degree views of the beach and Gulf',
      'Gulf-front primary bedroom with balcony access',
      'Covered parking garage',
      'Connected sky bridge with Sky Bar',
      'Two beach chairs and umbrella setup included March 1 - October 31',
    ],
  },
  {
    heading: 'The kitchen',
    items: [
      'Black granite countertops',
      'Top-of-the-line appliances',
      'Keurig coffee system',
      'Breakfast bar seating for 2',
      'Dining table seats 6',
      'Kitchen equipment and supplies provided',
    ],
  },
  {
    heading: 'Sleeping spaces',
    items: [
      'Primary bedroom: Gulf-front, king bed, private balcony door',
      'Primary bathroom: double sinks, garden tub, separate walk-in shower',
      'Guest bedroom: queen bed with private access to shared bathroom',
      'Bunk area: twin bunk beds',
    ],
  },
  {
    heading: 'Resort amenities',
    items: [
      'Several pools',
      'Hot tub',
      'Splash pad',
      'Whirlpool spa grotto',
      'Tropical pool deck',
      'On-site Starbucks',
      'Poolside cafe',
    ],
  },
  {
    heading: 'The area',
    items: [
      'Pier Park just down the street',
      'More than 130 shops, restaurants, and entertainment venues nearby',
      'Grand 16 IMAX Theater nearby',
      'Shipwreck Island Water Park less than 2 miles away',
      'Centrally located between Publix Sports Complex and Frank Brown Park',
    ],
  },
];

export const reviews: PropertyReview[] = [];

export const conciergeConfig: PropertyConciergeConfig = {
  propertyId: 'bella-vita',
  propertyName: 'Bella Vita',
  introText:
    'Hello — I’m here to help you get to know Bella Vita. Ask about the Gulf-front views, balcony, resort amenities, sleeping layout, or whether it fits your trip.',
  seedQuestion: 'Is Bella Vita Gulf front?',
  starters: [
    'Is it Gulf front?',
    'How many guests does it sleep?',
    'Tell me about the balcony.',
    'What resort amenities are included?',
    'What is nearby?',
  ],
};

export const inquiryData: PropertyInquiryData = {
  propertyName: 'Bella Vita',
  propertyLocation: 'Emerald Beach Resort, Panama City Beach',
  sleeps: '6',
};

export const stickyBarData: StickyBookBarData = {
  propertyId: 'bella-vita',
  propertyName: 'Bella Vita',
  location: 'Emerald Beach Resort · Panama City Beach',
  bedrooms: '2 bed',
  sleeps: 'Sleeps 6',
};
